// Clickable world fixtures, buildings/props you can interact with by tapping the
// map art (as opposed to the wandering NPC cast in npcs.ts). Like portals + NPCs,
// these are authored client-side: the maps ship no interaction metadata, so each
// fixture is a hand-placed hit rectangle over the spot the art already draws.
//
// Right now that's just the card shop. Domino City has no clock-tower interior to
// warp into, so the shop is the storefront itself, clicking the café building in
// Station Square opens the pack-buying overlay in place.

export type InteractKind = "shop";

export interface WorldInteractable {
  /** Stable per-placement id. */
  id: string;
  /** What clicking it does. */
  kind: InteractKind;
  /** Floating label shown above the fixture (also the hover affordance). */
  label: string;
  /** Hit rectangle in world px (x,y = top-left). */
  x: number;
  y: number;
  w: number;
  h: number;
}

const MAP_INTERACTABLES: Record<string, WorldInteractable[]> = {
  // Card Shop Street, the Kame Game shop. The "GAME" storefront in the top-left
  // (the building that literally spells GAME, with the OPEN door + green mat). Tapping
  // it opens the Domino card shop (Original/DM era, see World.svelte: shop_domino → kame).
  map_d02: [
    { id: "shop_domino", kind: "shop", label: "Kame Game", x: 190, y: 220, w: 320, h: 320 },
  ],
  // Duel Academy main hall, Dorothy's card shop. The building in the centre of
  // the hall literally reads "CARD SHOP"; its atari zone (≈x1112–1476 y660–916)
  // is NOT a warp (we have no academy shop interior), so clicking the storefront
  // opens the same pack-shop overlay as Domino's café.
  map_a02: [
    { id: "shop_academy", kind: "shop", label: "Card Shop", x: 1112, y: 660, w: 364, h: 256 },
  ],
};

export function interactablesFor(mapId: string): WorldInteractable[] {
  return MAP_INTERACTABLES[mapId] ?? [];
}
